import {SizeType} from '@vio/atlas/Image'

/**
 * GridGallery helper to build the grid template and grid-area
 * @param numImages - The number of images in the gallery
 * @returns - Grid config CSS
 */
export const buildGridGalleryGridArea = (mainColumnWidth: string) => {
  return `
    &.--5-images {
        grid-template-columns: ${mainColumnWidth || '55%'} 1fr 1fr;
        grid-template-rows: repeat(2, 1fr);

        > div:nth-of-type(1) {
          grid-area: 1 / 1 / 3 / 2;
        }

        > div:nth-of-type(2) {
          grid-area: 1 / 2 / 2 / 3;
        }

        > div:nth-of-type(3) {
          grid-area: 1 / 3 / 2 / 4;
        }

        > div:nth-of-type(4) {
          grid-area: 2 / 2 / 3 / 3;
        }

        > div:nth-of-type(5) {
          grid-area: 2 / 3 / 3 / 4;
        }
    }
    &.--4-images {
        grid-template-columns: ${mainColumnWidth || '55%'} 1fr 1fr;
        grid-template-rows: repeat(2, 1fr);

        > div:nth-of-type(1) {
          grid-area: 1 / 1 / 3 / 2;
        }

        > div:nth-of-type(2) {
          grid-area: 1 / 2 / 2 / 3;
        }

        > div:nth-of-type(3) {
          grid-area: 2 / 2 / 3 / 3;
        }

        > div:nth-of-type(4) {
          grid-area: 1 / 3 / 3 / 4;
        }
    }
    &.--3-images {
        grid-template-columns: ${mainColumnWidth || '55%'} 1fr 1fr;
        grid-template-rows: repeat(2, 1fr);

        > div:nth-of-type(1) {
          grid-area: 1 / 1 / 3 / 2;
        }

        > div:nth-of-type(2) {
          grid-area: 1 / 2 / 3 / 3;
        }

        > div:nth-of-type(3) {
          grid-area: 1 / 3 / 3 / 4;
        }
    }
    &.--2-images {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);

        > div:nth-of-type(1) {
          grid-area: 1 / 1 / 3 / 2;
        }

        > div:nth-of-type(2) {
          grid-area: 1 / 2 / 3 / 3;
        }
    }
    &.--1-image {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);

        > div:nth-of-type(1) {
          grid-area: 1 / 1 / 3 / 3;
        }
    }
  `
}

/**
 * Get the appropriate image size based on the number of images and the current image index.
 * It assumes that for 5 images, the first image should be larger than the rest
 *
 * @param numImages - The total number of images.
 * @param imageIndex - The current image index.
 * @returns `SizeType` - The size of the image
 */
export function getImageSize(numImages: number, imageIndex: number): SizeType {
  // Specific logic for 5 images: only the first image should be larger
  if (numImages === 5 && imageIndex === 0) {
    return 'lightbox'
  }

  // Return main size for all other cases
  return 'main'
}
